import TipoPedidoService from "@/services/TipoPedidoService";

export const tipoPedido = {
  namespaced: true,
  state: {
    tipoPedido: {},
  },
  actions: {
    getTipoPedido({ commit }, payload) {
      return TipoPedidoService.GetTipoPedido(payload).then(
        (tipoPedido) => {
          return Promise.resolve(tipoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTipoPedido({ commit }, payload) {
      return TipoPedidoService.PostTipoPedido(payload).then(
        (tipoPedido) => {
          return Promise.resolve(tipoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTipoPedido({ commit }, payload) {
      return TipoPedidoService.PutTipoPedido(payload).then(
        (tipoPedido) => {
          return Promise.resolve(tipoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTipoPedido({ commit }, payload) {
      return TipoPedidoService.DeleteTipoPedido(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTipoPedidoOData({ commit }, payload) {
      return TipoPedidoService.GetTipoPedidoOData(payload).then(
        (tipoPedido) => {
          return Promise.resolve(tipoPedido);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tipoPedido;
